import React from 'react';
import { ITextboxProps } from './Textbox.models';

const Textbox = (props: ITextboxProps) => {
    const {
        label,
        className,
        formGroupClassName,
        htmlFor,
        mandatory,
        id,
        name,
        type,
        placeholder,
        value,
        onChange,
        maxLength,
        disabled,
        autoFocus,
        onBlur,
        autoComplete,
        errorMessage
    } = props;
    let inputClass = errorMessage ? 'is-invalid form-control' : className ?? 'form-control ';

    return (
        <div className={formGroupClassName ?? 'form-group'}>
            {(label) ? (
                <label htmlFor={htmlFor}>
                    {label}
                    {mandatory ? <span className="mandatory">*</span> : null}
                </label>
            ) : null}
            <React.Fragment>
                <input
                    {...props}
                    id={id}
                    name={name}
                    type={type ?? 'text'}
                    className={inputClass}
                    placeholder={placeholder}
                    value={value === undefined ? '' : value}
                    onChange={onChange}
                    autoFocus={autoFocus}
                    maxLength={maxLength}
                    disabled={disabled}
                    onBlur={onBlur}
                    autoComplete={autoComplete ?? 'off'}
                />
                {errorMessage
                    ? <span className={'invalid-feedback'}>{errorMessage}</span>
                    : null}
            </React.Fragment>
        </div>
    );
}

export default Textbox;
